export default {
  already_have_account: 'Already have an Account?',
  create_account: 'Create an Account',
  email_address: 'Email address',
  dont_have_account: 'Don\'t have account?',
  forgot_password: 'Forgot Password',
  forgot_your_password: 'Forgot your password?',
  forgot_instruction: 'Enter your email address and we\'ll send you a link to reset your password.',
  login_to_pilihlaptop: 'Log in to PilihLaptop',
  register: 'Register',
  register_pilihlaptop: 'Register at PilihLaptop',
  reset: 'Reset',
  reset_password: 'Reset Password',
  reset_success: 'We have just sent you a link to reset your password. This link is valid for 24 hours. Afterwards, you can have a new link sent to you anytime by requesting a reset password again.',
};
